module.exports = __webpack_public_path__ + "static/media/logo-light-fr.8350ec30.svg";